// src/features/analytics/pushPageView.ts
declare global {
  interface Window {
    dataLayer?: any[]
  }
}

export function pushPageView() {
  try {
    const path = location.pathname + location.search + location.hash
    ;(window.dataLayer = window.dataLayer || []).push({
      event: "page_view",
      page_title: document.title,
      page_location: window.location.href, // full URL
      page_path: path, // path+qs+hash
    })
  } catch {
    /* no-op */
  }
}
